//region :: Imports ::
import {MNullable} from '../Utils';
import MNSwagResult, {MValidationErrors} from './NSwagResult';

//endregion

/** */
class MNSwagReplyResult<TReply extends object> {

    public readonly reply: MNullable<TReply>;
    public readonly exception: MNullable<any>;
    public readonly validationErrors: MNullable<MValidationErrors>;
    public readonly failed: boolean;
    public readonly hasValidationErrors: boolean;

    /** */
    private constructor(reply: MNullable<TReply>, exception: MNullable<any>) {

        this.reply = reply;
        this.exception = exception;
        this.validationErrors = MNSwagResult.getValidationErrors(exception);
        this.failed = this.exception !== null;
        this.hasValidationErrors = this.validationErrors !== null;

    }

    /** */
    public static ok<TReply extends object>(reply: TReply): MNSwagReplyResult<TReply> {
        return new MNSwagReplyResult<TReply>(reply, null);
    }

    /** */
    public static notOk<TReply extends object>(exception: any): MNSwagReplyResult<TReply> {
        return new MNSwagReplyResult<TReply>(null, exception);
    }

    /** */
    public throwIfFailed(): void {

        if(this.failed) {
            throw this.exception;
        }

    }

}

export default MNSwagReplyResult;
